import { createContext, useContext, useEffect, useReducer } from "react";
import {
	USER_REDUCER_CREATE,
	USER_REDUCER_DELETE,
	USER_REDUCER_GET_ALL_USERS,
	USER_REDUCER_UPDATE,
} from "../common/constants";
import { UserDataReducer } from "../Reducers/UserDataReducer";
import { LoadingContext } from "./LoadingContext";

export const UserContext = createContext();

const UserContextProvider = (props) => {
	const [userData, setUserDataDispatcher] = useReducer(UserDataReducer, []);
	const { loadingData, setLoadingData } = useContext(LoadingContext);

	const getAllUsersDataFromContext = (cb) => {
		setLoadingData({
			is_loading: true,
			message: "Loading users data....",
		});

		setUserDataDispatcher({
			type: USER_REDUCER_GET_ALL_USERS,
			loading: true,
			dispatch: setUserDataDispatcher,
			callback: () => {
				setLoadingData({
					is_loading: false,
					message: "",
				});
				cb && cb();
			},
		});
	};

	const createUserFromContext = (data, cb) => {
		setLoadingData({
			is_loading: true,
			message: "Creating new user....",
		});

		setUserDataDispatcher({
			type: USER_REDUCER_CREATE,
			data,
			callback: () => {
				setLoadingData({
					is_loading: false,
					message: "",
				});
				cb && cb();
			},
		});
	};

	const updateUserDataFromContext = (id, data, cb) => {
		setLoadingData({
			is_loading: true,
			message: "Updating user data....",
		});

		setUserDataDispatcher({
			type: USER_REDUCER_UPDATE,
			id,
			data,
			callback: () => {
				setLoadingData({
					is_loading: false,
					message: "",
				});
				cb && cb();
			},
		});
	};

	const delteUserDataFromContext = (id, cb) => {
		setLoadingData({
			is_loading: true,
			message: "Deleting user data....",
		});

		setUserDataDispatcher({
			type: USER_REDUCER_DELETE,
			id,
			callback: () => {
				setLoadingData({
					is_loading: false,
					message: "",
				});
				cb && cb();
			},
		});
	};

	return (
		<UserContext.Provider
			value={{
				userData,
				getAllUsersDataFromContext,
				createUserFromContext,
				updateUserDataFromContext,
				delteUserDataFromContext,
			}}
		>
			{props.children}
		</UserContext.Provider>
	);
};

export default UserContextProvider;
